import Close from './close';

export default Close;
